import { render, staticRenderFns } from "./fix-gb-whatsapp-ban.vue?vue&type=template&id=249b352a"
import script from "./fix-gb-whatsapp-ban.vue?vue&type=script&lang=js"
export * from "./fix-gb-whatsapp-ban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports